var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkSimpleActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 3C17.6478 3 18.0292 3.15815 18.3105 3.43945C18.5919 3.72076 18.75 4.10218 18.75 4.5V21C18.7498 21.1337 18.7134 21.2647 18.6455 21.3799C18.5776 21.495 18.4802 21.5905 18.3633 21.6553C18.2464 21.72 18.114 21.7524 17.9805 21.749C17.847 21.7455 17.7169 21.7063 17.6035 21.6357L12 18.1338L6.39746 21.6357C6.28398 21.7066 6.1533 21.7455 6.01953 21.749C5.88581 21.7525 5.75373 21.7201 5.63672 21.6553C5.51969 21.5904 5.42148 21.4961 5.35352 21.3809C5.28554 21.2656 5.25007 21.1338 5.25 21V4.5C5.25 4.10218 5.40815 3.72076 5.68945 3.43945C5.97076 3.15815 6.35218 3 6.75 3H17.25ZM7.83301 9.125C7.61223 9.12506 7.40032 9.19058 7.24414 9.30762C7.08786 9.42483 7 9.58424 7 9.75C7 9.91576 7.08786 10.0752 7.24414 10.1924C7.40032 10.3094 7.61223 10.3749 7.83301 10.375H16.167C16.3878 10.3749 16.5997 10.3094 16.7559 10.1924C16.9121 10.0752 17 9.91576 17 9.75C17 9.58424 16.9121 9.42483 16.7559 9.30762C16.5997 9.19058 16.3878 9.12506 16.167 9.125H7.83301Z",
    fill: "#09AA6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkSimpleActive);
export default __webpack_public_path__ + "static/media/bookmark-simple-active.4e0c1df07c25134fbbadeae4dc416254.svg";
export { ForwardRef as ReactComponent };